import React from 'react';
import {PuffLoader} from 'react-spinners'

const AnimationSpinner = ({ show }) => {
	return (
		<div id='animation-bar-spinner' style={{ display: show ? 'block' : 'none' }}>
			<div className="animation-spinner">
				<PuffLoader
					color="#d52aba"
					loading={show}
					size={100}
					speedMultiplier={2}
				/>
			</div>
		</div>
	);
};

export default AnimationSpinner;
